import React from 'react';
import Technology from './ProductDetail/Technology';
import Design from './ProductDetail/Design';
import Quality from './ProductDetail/Quality';
import Case from './ProductDetail/Case';
import Spec from './ProductDetail/Spec';
import './Product.scss';

const Product = ({ setProductPosition }) => {
  return (
    <div className="product">
      <Technology setProductPosition={setProductPosition} />
      <Design setProductPosition={setProductPosition} />
      <Quality setProductPosition={setProductPosition} />
      <Case setProductPosition={setProductPosition} />
      <Spec setProductPosition={setProductPosition} />
    </div>
  );
};

export default Product;
